import { formatStatusLabel } from '../lib/format-status';
import styles from '../pages/app/AppPages.module.css';

export function StatusBadge({ status }: { status: string }): React.JSX.Element {
  const tone =
    status === 'ACTIVE' ||
    status === 'APPROVED' ||
    status === 'ACCEPTED' ||
    status === 'CONFIRMED' ||
    status === 'PAID' ||
    status === 'SUCCEEDED' ||
    status === 'SUCCESSFUL' ||
    status === 'COMPLETED' ||
    status === 'HEALTHY'
      ? styles.badgeActive
      : status === 'DEACTIVATED' ||
          status === 'SUSPENDED' ||
          status === 'REJECTED' ||
          status === 'CANCELLED' ||
          status === 'DEFAULTED' ||
          status === 'FAILED' ||
          status === 'EXPIRED' ||
          status === 'UNHEALTHY' ||
          status === 'OVERDUE'
        ? styles.badgeDanger
        : styles.badgeNeutral;

  return <span className={`${styles.badge} ${tone}`}>{formatStatusLabel(status)}</span>;
}
